const getScrollPos = () => {
  return (window.pageYOffset || window.scrollTop) - (window.clientTop || 0) || 0
}

export default getScrollPos
